import type { PublicKey } from "@solana/web3.js";
import { NATIVE_SOL } from "@stepfinance/common";

import { generateOneToOneNotificationDescription, notify } from "../utils/notifications";

// Used for SOL Staking platorms (i.e. Socean)

export const notifyStakeSuccess = (
  stakedAmount: number,
  receivedAmount: number,
  tokenAddress: string | PublicKey,
  txId?: string,
) => {
  notify({
    type: "success",
    description: generateOneToOneNotificationDescription({
      tokenA: { action: "staked", amount: stakedAmount, mint: NATIVE_SOL, type: "decrease" },
      tokenB: {
        action: "received",
        amount: receivedAmount,
        mint: tokenAddress,
        type: "increase",
      },
    }),
    message: "You staked SOL",
    txId,
  });
};

export const notifyUnstakeSuccess = (
  unstakedAmount: number,
  receivedAmount: number,
  tokenSymbol: string,
  tokenAddress: string | PublicKey,
  txId?: string,
) => {
  notify({
    type: "success",
    description: generateOneToOneNotificationDescription({
      tokenA: {
        action: "unstaked",
        amount: unstakedAmount,
        mint: tokenAddress,
        type: "decrease",
      },
      tokenB: {
        action: "received",
        amount: receivedAmount,
        mint: NATIVE_SOL,
        type: "increase",
      },
    }),
    message: `You staked ${tokenSymbol}`,
    txId,
  });
};
